import { ReactElement, useState } from 'react'
import WarningAmberIcon from '@mui/icons-material/WarningAmber'
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Stack,
  Typography,
} from '@mui/material'

interface Props {
  apiURL: string
}

const normalizeApiURL = (apiURL: string) => apiURL.trim().replace(/\/+$/, '') + '/'

const labelFromApiURL = (apiURL: string) => {
  const normalized = normalizeApiURL(apiURL)

  if (normalized === 'https://app-api-testing.timberleicht.de/') {
    return 'Testing'
  }

  if (normalized === 'https://app-api.timberleicht.de/') {
    return 'Production'
  }

  return null
}

const PreviewDeploymentWarningDialog = ({ apiURL }: Props): ReactElement => {
  const [open, setOpen] = useState(true)
  const apiLabel = labelFromApiURL(apiURL)

  return (
    <Dialog open={open} onClose={() => undefined} disableEscapeKeyDown fullWidth maxWidth="sm">
      <DialogTitle sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
        <WarningAmberIcon color="warning" />
        Hinweis zum Preview-Deployment
      </DialogTitle>
      <DialogContent>
        <Stack spacing={2} sx={{ pt: 1 }}>
          <Typography>
            Diese Umgebung ist nur zum Preview neuer Features gedacht. Je nach Konfiguration
            arbeitet sie trotzdem gegen Testing- oder sogar Production-APIs.
          </Typography>
          <Typography>
            Bitte bearbeite hier nur Projekte, bei denen im schlimmsten Fall auch ein ungueltiger
            Projektzustand vertretbar ist. Wenn du unsicher bist, teste besser mit einer
            Sicherungskopie.
          </Typography>
          <div>
            <Typography variant="subtitle2" color="text.secondary">
              Aktuelle API
            </Typography>
            {apiLabel ? (
              <Typography>
                {apiLabel} ({apiURL})
              </Typography>
            ) : (
              <Typography sx={{ wordBreak: 'break-all' }}>{apiURL}</Typography>
            )}
          </div>
        </Stack>
      </DialogContent>
      <DialogActions>
        <Button
          onClick={() => {
            window.close()
            window.location.href = 'about:blank'
          }}
        >
          Verlassen
        </Button>
        <Button variant="contained" onClick={() => setOpen(false)} autoFocus>
          Verstanden
        </Button>
      </DialogActions>
    </Dialog>
  )
}

export default PreviewDeploymentWarningDialog
